export const ipListRoutes = {
  path: '',
  name: 'IPList',
  component: () => import('@/views/ip/index.vue'),
  meta: {
    hidden: false,
    title: 'IP Monitor'
  }
}

export const monitorListRoutes = {
  path: '',
  name: 'MonitorList',
  component: () => import('@/views/monitor/index.vue'),
  meta: {
    hidden: false,
    title: 'Match Monitor'
  }
}
